import { I18nMarkup } from "@hopper-b2b/i18n";
import dayjs from "dayjs";

interface FareDetailsSliceHeaderProps {
  destination: string;
  date: Date;
  airline: string;
  isDeparture?: boolean;
}

const FareDetailsSliceHeader = ({
  destination,
  date,
  airline,
  isDeparture = true,
}: FareDetailsSliceHeaderProps) => {
  const formattedDate = dayjs(date).format("ddd, MMM D");
  const replacements = { location: destination, date: formattedDate };

  return (
    <>
      {isDeparture ? (
        <I18nMarkup
          tKey="flightShopReview.outboundCardHeader"
          replacements={replacements}
        />
      ) : (
        <I18nMarkup
          tKey="flightShopReview.returnCardHeader"
          replacements={replacements}
        />
      )}
      <p className="fare-slice-header-airline">{airline}</p>
    </>
  );
};

export default FareDetailsSliceHeader;
